// /src/pdf/builders/peak/buildDoc.js
export function buildPeakDoc({
  t, shortcode, stationName,
  period, date1, date2,
  peakInfo,
  fmtNumber, locale,
  logoDataUrl,
  chartDataUrl,
  serviceName
}) {
  // Человеко-понятное описание периода по локали
  const stripLeadingIcon = (text) => (text || '').replace(/^📅\s*/u, '').trimStart();
  const formatLine = (label, value) => `${stripLeadingIcon(label)} ${value}`.trim();
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('peak.title')) || '';

  let periodLines = [];
  if (period === 'day') {
    periodLines = [formatLine(t('peak.date'), date1)];
  } else if (period === 'week') {
    periodLines = [formatLine(t('peak.end_of_week'), date2)];
  } else if (period === 'month') {
    periodLines = [formatLine(t('peak.end_of_period'), date1)];
  }

  const content = [];

  // Лого слева (если доступно)
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // Заголовок + период
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: periodLines,
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    }
  );

  // ▼ если есть картинка графика — вставляем её после шапки
  if (chartDataUrl) {
    content.push({
      image: chartDataUrl,
      width: 520,
      margin: [0, 0, 0, 10]
    });
  }

  // Опционально показываем строку пика (если задана на странице)
  if (peakInfo) {
    content.push({
      text: peakInfo,
      margin: [0, 0, 0, 10],
      fontSize: 11,
      bold: true
    });
  }

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
    },
  };
}

export { buildPeakDoc as default };
